import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@api-ui-app/src/app/app.state';
import { DialogService } from '@gelato-api-ui/sdk/src/lib/shared/dialog/dialog.service';
import { take, tap } from 'rxjs/operators';
import { LoadStoresList, setSelectedStore } from '@api-ui-app/src/app/ngrx/e-commerce-stores.actions';
import { getDefaultStoresListRequest } from '@gelato-api-ui/core/e-commerce/helpers/getDefaultStoresListRequest';
import { AuthService } from '@gelato-api-ui/core/auth/auth.service';
import { getStoresList } from '@api-ui-app/src/app/ngrx/e-commerce-stores.selector';
import { ECommerceStoreSelectionModalContainerComponent } from './containers/e-commerce-store-selection-modal-container/e-commerce-store-selection-modal-container.component';
import { EStore } from '@gelato-api-ui/core/e-commerce/e-store';
import { EcommerceStoreSelectionModalData } from '@api-ui-app/src/app/e-commerce-store-selection-modal/types/ecommerce-store-selection-modal-data';

@Injectable({
  providedIn: 'root',
})
export class ECommerceStoreSelectionModalFacade {
  readonly clientId$ = this.authService.getClientId();
  readonly storesList$ = this.store.select(getStoresList);

  constructor(
    private readonly store: Store<AppState>,
    private readonly dialogService: DialogService,
    private readonly authService: AuthService,
  ) {}

  loadStoresList() {
    this.clientId$
      .pipe(
        take(1),
        tap((clientId: string) => {
          this.store.dispatch(new LoadStoresList(getDefaultStoresListRequest(clientId), false));
        }),
      )
      .subscribe();
  }

  openModal(config?: EcommerceStoreSelectionModalData): void {
    this.loadStoresList();
    this.dialogService.open(ECommerceStoreSelectionModalContainerComponent, {
      data: {
        title: 'txt_product_template_store_selection_modal_title',
        subtitle: 'txt_which_store_do_you_want_to_upload_design',
        selectStoreAction: config?.selectStoreAction,
      },
    });
  }

  selectStore(store: EStore) {
    this.store.dispatch(setSelectedStore({ payload: store }));
  }
}
